/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2021.

!Changelog

2021
	19-11-2021
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_digidag = {};

(function(){

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	
	this.onready = function() {

		/*
		Start: Open welcome modal or start tour immediatly
		*/
		switch(url[1]) {
			default:

				modal.open('onboarding');
				//specific_digidag.startTour();

			break;

			case 'ouder':
			case 'kind':
			case 'leerkracht':

				if(url[2] != '') {

					// switch(url[2]) {

					// 	default:

					// 		specific_digidag.startTour();

					// 	break;

					// 	case 'contact':
					// 	case 'kort-en-bondig':
					// 		alert(1);
					// 	break;

					// }

					specific_digidag.startTour();

				} else {

					window.location = globalUrl;
				}

			break;

		}

		/*
		Listener: Bind
		*/
		$(document).on('click','.js-start',function() {

			specific_digidag.onboarding(
				$(this).data('category')
			);

		});

		$(document).on('click','.js-startnow',function() {
			
			specific_digidag.startTour();

			/*
			Pause: Audio
			*/
			specific_digidag_audioplayer.togglePlayingPause();

			/*
			Set: Played
			*/
			specific_digidag_audioplayer.setPlayed(0,1);


		});

		/*
		Init: Audioplayer
		*/
		specific_digidag_audioplayer.onready();
		
	};
		
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	/*
	Tour: Start
	*/
	this.startTour = function() {

		/*
		Modal: Close
		*/
		modal.close();
		
		/*
		Menu: Show puller
		*/
		specific_digidag_menu.togglePuller();

		/*
		Logo: Set Active
		*/
		$('.js-logo').addClass('active');

		/*
		Go count for CTA
		*/
		var countToCTA = setInterval(function() {

			if(
				$(window).width() > 500 &&
				_isDigidagCTA == 0 &&
				$('.js-settings-ispage').val() == 'false' &&
				$('.js-settings-menu').val() == 'false'
			) {

				$('.js-cta').fadeIn();
				_isDigidagCTA  = 1;

			} else {

				// $('.js-cta').fadeOut();
				// _isDigidagCTA  = 0;

			}

		},5000);

	};

	/*
	Onboarding
	*/
	this.onboarding = function(
		category
	) {

		var _delay = 3000; // 3000;

		/*
		Set: Category
		*/
		$('.js-settings-category').val(
			category
		);

		/*
		Url: Set
		*/
		window.history.pushState(
			'',
			'New URL: ' + globalUrl + '/' + category + '/centrale-hal/-214|0|0',
			globalUrl + '/' + category + '/centrale-hal/-214|0|0'
		);

		/*
		Audioplayer
		*/
		specific_digidag_audioplayer.load(
			category + '-centrale-hal.mp3'
		);

		/*
		Onboarding modal: Part 1 hide and Part 2 show
		*/
		$('.js-step-1').hide();
		$('.js-step-2').show();

		/*
		Preload animation
		*/
		setTimeout(function() { 
		
			var _preloader 			= $('.js-preloader').find('.tracker');
			var _preloader_width 	= $('.js-preloader').width();

			_preloader.animate({
				'width' : _preloader_width + 'px'
			},_delay);

		},500);

		/*
		Preloader: Interval
		*/
		preloaderInterval = setInterval(function() { 

			var _preloader_width 				= $('.js-preloader').width();
			var _preloader_tracker_width		= $('.js-preloader').find('.tracker').width();

			var _preloader_width_percentage 	= (100 * _preloader_tracker_width) / _preloader_width;
			_preloader_width_percentage 		= _preloader_width_percentage.toFixed(0);

			$('.js-preloader').find('.percentage').find('span').html(_preloader_width_percentage);

			/*
			Done?
			*/
			if(_preloader_width_percentage > 80) {

				/*
				Fade out / fade in
				*/
				$('.js-preloader').find('.percentage').fadeOut(0);

				$('.js-preloader').fadeOut(200,function() {
					$('.js-buttons').fadeIn();
					$('.js-step-2').find('.js-loading').hide();
					$('.js-step-2').find('.js-gelukt').show();
				});

				/*
				Interval: Clear
				*/
				clearInterval(preloaderInterval);
			}

		},100);

	};

	/*
	Goto page
	*/
	this.gotoPage = function() {

		$('.js-button-kernwaarden').click();

	};

}).apply(specific_digidag); 